<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-card-title>
      OT Bill: Cancel List
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>

      <v-col cols="12" sm="6" md="3">
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="date"
              label="Select Date"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              hide-details
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="date"
            @input="menu2 = false"
            @click:date="dateSelect"
            type="month"
            v-on:change="initialize()"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <template>
          <v-text-field
            v-model="search"
            prepend-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </template>
      </v-col>

      <v-col cols="12" sm="6" md="1">
        <template>
          <v-row align="center" justify="space-around">
            <v-btn
              depressed
              color="primary"
              append-icon="mdi-printer"
              @click="printList"
              >Print
            </v-btn>
          </v-row>
        </template>
      </v-col>
    </v-card-title>
    <div id="print">
      <v-card>
        <v-data-table
          :headers="headers"
          :items="itemsWithSno"
          class="elevation-1"
          :search="search"
          dense
          :loading="loadingstatus"
          loading-text="Loading... Please wait"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:item.operation_subhead="{ item }">
            <span v-if="item.operation">{{ item.operation.name }}</span>
            <v-chip
              v-if="item.operation_subhead"
              class="ma-2"
              color="error"
              outlined
              small
            >
              {{ item.operation_subhead }}
            </v-chip>
          </template>
          <template v-slot:item.opp_status="{ item }">
            <v-chip :color="getColor(item.opp_status)" dark>
              {{ item.opp_status.toUpperCase() }}
            </v-chip>
          </template>
          <template v-slot:item.paid_amount="{ item }">
            <div class="d-flex justify-center font-weight-black">
              {{ b_number_format(item.paid_amount) }}
            </div>
          </template>
          <template v-slot:item.hospital_amount="{ item }">
            <div class="d-flex justify-center font-weight-black">
              {{ b_number_format(item.hospital_amount) }}
            </div>
          </template>
          <template v-slot:item.doctor_amount="{ item }">
            <div class="d-flex justify-center font-weight-black">
              {{ b_number_format(item.doctor_amount) }}
            </div>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  @click="ot_details(item)"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  color="orange"
                  label
                  outlined
                  small
                  ><v-icon> mdi-chevron-double-right </v-icon>
                </v-chip>
              </template>
              <span>OT Registration Details</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  @click="recieve_money(item)"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  open
                  color="primary"
                  label
                  outlined
                  small
                >
                  <v-icon> mdi-cash </v-icon>
                </v-chip>
              </template>
              <span>Receive Money</span>
            </v-tooltip>
            <v-tooltip top>
              <template
                v-if="item.opp_status != 'cancel'"
                v-slot:activator="{ on, attrs }"
              >
                <v-chip
                  @click="ot_refund(item)"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  open
                  color="primary"
                  label
                  outlined
                  small
                  ><v-icon> mdi-undo-variant </v-icon>
                </v-chip>
              </template>
              <span>Refund to Patient</span>
            </v-tooltip>
          </template>
          <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">Reset</v-btn>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </div>
</template>
<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../../js/setup";
export default {
  data() {
    return {
      search: "",
      date: new Date().toISOString().substr(0, 7),
      nowDate: new Date().toISOString().substr(0, 7),
      menu2: false,
      loadingstatus: true,
      summary: {},
      headers: [
        {
          text: "SL #",
          value: "sno",
        },
        {
          text: "OT ID",
          align: "start",
          value: "registration_no",
        },
        { text: "OT Date", value: "opp_date", Key: "Date" },
        {
          text: "ID",
          value: "patient_id",
        },
        { text: "Patient Name", value: "patient.patient_name" },
        { text: "Doctor", value: "doctor.dr_name" },
        { text: "Operation Name", sortable: true, value: "operation_subhead" },

        { text: "Paid Amount", value: "paid_amount" },
        { text: "Status", value: "opp_status" },
        { text: "Comments", value: "cancel_description" },
        { text: "Cancel By", value: "cancel_by.full_name" },
      ],

      desserts: [],
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Operations",
          disabled: true,
          href: "patients",
        },
      ],
      returnUrl: atshq.defaults.headers.common.app_URL,
    };
  },
  // Fetches posts when the component is created.
  created() {
    this.initialize(this.date);
    // console.log(this.$store.getters.getUserName);
    // console.log(atshq.defaults.headers.common.api_URL);
  },
  computed: {
    itemsWithSno() {
      return this.desserts.map((d, index) => ({ ...d, sno: index + 1 }));
    },
  },
  methods: {
    initialize() {
      atshq
        .get("ot-module/ot-bill-cancel?date=" + this.date)
        .then((response) => {
          this.desserts = response.data.data;
          this.loadingstatus = false;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    b_number_format(n) {
      return n.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    },
    getColor(status) {
      if (status == "open") return "orange";
      else if (status == "close") return "green";
      else if (status == "cancel") return "red";
    },
    printList() {
      var disp_setting = "toolbar=yes,location=no,";
      disp_setting += "directories=yes,menubar=yes,";
      disp_setting += "scrollbars=yes,width=650, height=600, left=100, top=25";
      var content_vlue = document.getElementById("print").innerHTML;
      var docprint = window.open("", "", disp_setting);
      docprint.document.open();
      docprint.document.write(
        '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"'
      );
      docprint.document.write(
        '"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">'
      );
      docprint.document.write(
        '<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">'
      );
      // docprint.document.write(
      //   "<head><title>" + this.doctor.dr_name + " || " + this.date + "</title>"
      // );
      docprint.document.write('<style type="text/css">body{ margin:0px;');
      docprint.document.write("font-family:verdana,Arial;color:#000;");

      docprint.document.write(
        "font-family:Verdana, Geneva, sans-serif; font-size:10px;}"
      );
      docprint.document.write(
        "table td, table th {border: 1px solid #ddd;padding: 0px; font-size:9px;}"
      );
      docprint.document.write(
        "table th, table th {padding-top: 12px;padding-bottom: 12px;text-align: left;background-color: #4CAF50;color: white;}"
      );
      docprint.document.write("table {width: 100%;}");

      docprint.document.write("a{color:#000;text-decoration:none;} </style>");
      docprint.document.write('</head><body onLoad="self.print()"><center>');
      docprint.document.write(content_vlue);
      docprint.document.write("</center></body></html>");
      docprint.document.close();
      docprint.focus();
    },
    dateSelect() {
      this.loadingstatus = true;
      this.initialize();
    },
    ot_details(item) {
      window.location.href = "/ot-registration/" + item.registration_no;
    },
    ot_refund(item) {
      window.location.href = "/otbill-refund/" + item.registration_no;
    },
    recieve_money(item) {
      window.location.href = "/otbill-received/" + item.registration_no;
    },
  },
};
</script>